import { SET_IS_SAME } from "../../constants";
import { getCustomerInformationFromLocalStorage } from "../../selectors";

import { createAction } from "../../utils";

const setIsSame = createAction(SET_IS_SAME);

export const setIsSameCustomer = (isSame) => (dispatch, getState) => {
  const customerData = getCustomerInformationFromLocalStorage(getState());

  const dataToStore = {
    ...customerData,
    isSame,
  };

  window.localStorage.setItem(
    "customerInformation",
    JSON.stringify(dataToStore),
  );

  dispatch(setIsSame(isSame));
};
